export default {
    apiKey: "AIzaSyCqVLu-zr5729qwRrgpSzFwU5oaij2UuNw",
    authDomain: "network-it-web.firebaseapp.com",
    databaseURL: "https://network-it-web.firebaseio.com",
    projectId: "network-it-web",
    storageBucket: "network-it-web.appspot.com",
    messagingSenderId: "55853594127",
    appId: "1:55853594127:web:80a90798464f90f5e6d57a",
    measurementId: "G-NYC2BJQL3X"
}